import React from "react";
import { Typography, Divider, useMediaQuery } from "@mui/material";
import "@fontsource/rubik/500.css";
import "@fontsource/rubik/400.css";
import ExpandInfo from "./ExpandInfo";

const Step7Casnic = () => {
  const isLaptop = useMediaQuery("(max-width: 1400px)");
  const isMobile = useMediaQuery("(max-width: 1024px)");

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? 0 : "140px",
          marginRight: isMobile ? -20 : "140px",
          marginTop: isMobile ? -50 : "50px",
        }}
      >
        {!isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: isLaptop ? "30rem" : "29rem",
              width: "4px",
              backgroundColor: "#29348f",
            }}
          />
        ) : (
          ""
        )}
        <div style={{ marginLeft: 34 }}>
          <div
            variant="contained"
            style={{
              backgroundColor: "#29348f",
              borderRadius: isMobile
                ? "20px 0px 0px 20px"
                : "0px 20px 20px 0px",
              textTransform: "none",
              height: 40,
              width: 80,
              paddingLeft: 16,
              paddingTop: 8,
              marginLeft: isMobile ? "auto" : "",
            }}
          >
            <Typography variant="body1" color="white">
              DEER
            </Typography>
          </div>
          <Typography variant="h6" sx={{ mt: 4 }}>
            Recepția instalației de racordare
          </Typography>
          <Typography variant="h6" sx={{ mt: 2, color: "#29348f" }}>
            Cât durează?
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            La termenul convenit în cadrul contractului de racordare
          </Typography>
          <Typography variant="h6" sx={{ mt: 4 }}>
            Emiterea certificatului de racordare
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            (După depunerea dosarului instalației de utilizare și finalizarea
            lucrărilor de racordare, vom emite Certificatul de Racordare al
            locului de consum.Certificatul de racordare este unul din
            documentele care stă la baza încheierii contractului de furnizare a
            energiei electrice.)
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            Soluție stabilită prin fișa de soluție
          </Typography>

          <Typography variant="h6" sx={{ mt: 2, color: "#29348f" }}>
            Cât durează?
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            3 zile lucrătoare de la recepția punerii în funcțiune a instalației
            de racordare, cu condiția depunerii la operatorul de rețea, a
            dosarului instalației de utilizare întocmit de executantul acesteia
          </Typography>
        </div>
        {isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: "43rem",
              width: "4px",
              backgroundColor: "#29348f",
              ml: 2,
            }}
          />
        ) : (
          ""
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? -30 : "140px",
          marginTop: "50px",
          marginRight: isMobile ? 0 : "140px",
          marginBottom: "60px",
        }}
      >
        <Divider
          orientation="vertical"
          sx={{
            height: "4rem",
            width: "4px",
            backgroundColor: "#29348f",
            mr: isMobile ? 3 : "",
          }}
        />
        <ExpandInfo />
      </div>
    </div>
  );
};
export default Step7Casnic;
